import { render, staticRenderFns } from "./WBzhTable.vue?vue&type=template&id=3d68fb7a&scoped=true"
import script from "./WBzhTable.vue?vue&type=script&lang=js"
export * from "./WBzhTable.vue?vue&type=script&lang=js"
import style0 from "./WBzhTable.vue?vue&type=style&index=0&id=3d68fb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d68fb7a",
  null
  
)

export default component.exports